import { SystemInfosApi as BackendSystemInfosApi } from '@liks/backend-svc-api/esm/apis/SystemInfosApi';
import { SystemInfosApi as LacSystemInfosApi } from '@liks/lac-svc-api/esm/apis/SystemInfosApi';
import { backendApiConfiguration } from './backendApi';
import { lacApiConfiguration } from './lacApi';

function normalizeBuildVersion(value: unknown): string {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.length > 0) {
      return trimmed;
    }
  }

  if (value != null && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    for (const key of ['version', 'buildVersion', 'applicationVersion']) {
      const candidate = record[key];
      if (typeof candidate === 'string' && candidate.trim().length > 0) {
        return candidate.trim();
      }
    }
  }

  throw new Error('Backend returned an invalid build version');
}

class SystemInfoService {
  private readonly backendApi = new BackendSystemInfosApi(
    backendApiConfiguration,
  );
  private readonly lacApi = new LacSystemInfosApi(lacApiConfiguration);

  async getBackendServiceVersion(): Promise<string> {
    const version =
      await this.backendApi.deLiksBaseBuildBoundaryBuildResourceGetVersion();
    return normalizeBuildVersion(version);
  }

  async getLacServiceVersion(): Promise<string> {
    const version =
      await this.lacApi.deLiksBaseBuildBoundaryBuildResourceGetVersion();
    return normalizeBuildVersion(version);
  }
}

export const systemInfoService = new SystemInfoService();
